"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUser = exports.updateUser = exports.getUsers = exports.addUser = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _rest = _interopRequireDefault(require("../api/rest"));

var addUser = (0, _toolkit.createAsyncThunk)('user/add', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, thunkAPI) {
    var _thunkAPI$getState, source, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _thunkAPI$getState = thunkAPI.getState(), source = _thunkAPI$getState.cms.config.source;
            _context.next = 3;
            return (0, _rest.default)('createUser', args, source);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
exports.addUser = addUser;
var getUsers = (0, _toolkit.createAsyncThunk)('user/get', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, thunkAPI) {
    var _thunkAPI$getState2, source, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _thunkAPI$getState2 = thunkAPI.getState(), source = _thunkAPI$getState2.cms.config.source;
            _context2.next = 3;
            return (0, _rest.default)('getUsers', args, source);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
exports.getUsers = getUsers;
var updateUser = (0, _toolkit.createAsyncThunk)('user/update', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, thunkAPI) {
    var _thunkAPI$getState3, source, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _thunkAPI$getState3 = thunkAPI.getState(), source = _thunkAPI$getState3.cms.config.source;
            _context3.next = 3;
            return (0, _rest.default)('updateUser', args, source);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}());
exports.updateUser = updateUser;
var deleteUser = (0, _toolkit.createAsyncThunk)('user/delete', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args, thunkAPI) {
    var _thunkAPI$getState4, source, response;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _thunkAPI$getState4 = thunkAPI.getState(), source = _thunkAPI$getState4.cms.config.source;
            _context4.next = 3;
            return (0, _rest.default)('deleteUser', args, source);

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}());
exports.deleteUser = deleteUser;